module.exports = __webpack_public_path__ + "img/banner33.eb3ed057.png";